import { createPinia } from 'pinia';

export const configuredPinia = () => createPinia(); // Local pinia
